import axios from 'axios'
import ShipmentPointsGroup from '@/dto/deliveries/ShipmentPointsGroup'
import {
  Currencies,
  DeliveryTypes,
  MeasureUnits,
  CalculatorTypes,
  CalculatorTypesGroups,
  DeliveredDuties,
} from '@/services/DictionariesService'

export interface PointsGroups {
  [key: number]: ShipmentPointsGroup
}

export interface InitialResponse {
  currencies: Currencies
  deliveryTypes: DeliveryTypes
  measureUnits: MeasureUnits
  pointsGroups: PointsGroups
  calculatorTypes: CalculatorTypes
  calculatorTypesGroups: CalculatorTypesGroups
  deliveredDuties: DeliveredDuties
  tabsMap: any
}

const ShipmentService = {
  load(): Promise<InitialResponse> {
    return axios.get('/admin/deliveries').then(response => response.data)
  },

  removeShipmentPoint(shipmentPointId: number) {
    return axios
      .delete(`/admin/shipment-points/${shipmentPointId}`)
      .then(response => response.data)
  },

  saveShipmentPoint({
    countryId,
    regionId,
    placeId,
  }: {
    countryId: number
    regionId: number
    placeId: number
  }) {
    return axios
      .post(`/admin/shipment-points`, {
        countryId,
        stateId: regionId,
        cityId: placeId,
      })
      .then(response => response.data.shipmentPoint)
  },

  togglePointStatus(shipmentPointId: number) {
    return axios
      .post(`/admin/shipment-points/${shipmentPointId}/toggle`)
      .then(response => response.data)
  },
}

export default ShipmentService
